import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface DeleteOfferResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function deleteOfferAction(requisitionId: string): Promise<ApiResponse<DeleteOfferResponse>> {
  return api.delete<ApiResponse<DeleteOfferResponse>>(`/offers/${requisitionId}`)
}
